import { NgIf } from '@angular/common';
import {Component, Inject, OnInit, ViewEncapsulation, inject} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {
    MAT_SNACK_BAR_DATA,
    MatSnackBar,
    MatSnackBarAction,
    MatSnackBarActions,
    MatSnackBarLabel,
    MatSnackBarRef,
  } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'snack-bar-component',
    templateUrl:'./snackbar.component.html',
    styleUrls: ['./snackbar.component.scss'],
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    imports: [MatButtonModule,MatTooltipModule, MatIconModule],
  })
  export class SnackBarComponent implements OnInit {
    constructor(
      public sbRef: MatSnackBarRef<SnackBarComponent>,
      @Inject(MAT_SNACK_BAR_DATA) public data: {
        messaggio : string;
      }
    ) {}
    ngOnInit() {}
  }
